import './GlowSubWidgets.css';
import React, {useState} from "react";

function EatBlock(props) {
    const [activeStep, setActiveStep] = useState(1)

    const eatingRoutineSteps = [
        "start podcast, documentary, or audiobook", 
        "start cooking food, cleaning while working",
        "eat! savor each bite equally lol",
        "take a quick walk or do a quick stretch flow",
        "clean up, ensure space is ready for back to work",
    ]

    function changeStep(trigger) {
        if (trigger === activeStep) {
            setActiveStep(activeStep+1)
        }
    }

    return (
        <div className="eatingRoutine">                
        <p className="glowHeaderText"> fuel </p>
                <p className="eatingHeaderSubText"> {eatingRoutineSteps[activeStep - 1]} </p>
                {activeStep === 6 &&
                    <p className="eatingHeaderSubText"> completed dinner routine - chill out until 18:00</p>
                }
                <div className="eatingRoutineBoxRow">
                        <div className="boxLineScreen"></div>
                        <div onClick={() => changeStep(1)} className="boxScreen">
                            {activeStep > 1 &&
                                <div className="innerBoxScreen innerMorning1"></div>
                            }
                            {activeStep === 1 &&
                                <div className="innerBoxScreen screenPulsing innerMorning1"></div>
                            }
                        </div>
                        <div onClick={() => changeStep(2)} className="boxScreen">
                            {activeStep > 2 &&
                                <div className="innerBoxScreen innerMorning2"></div>
                            }
                            {activeStep === 2 &&
                                <div className="innerBoxScreen screenPulsing innerMorning2"></div>
                            }
                        </div>
                        <div onClick={() => changeStep(3)} className="boxScreen">
                            {activeStep > 3 &&
                                <div className="innerBoxScreen innerMorning3"></div>
                            }
                            {activeStep === 3 &&
                                <div className="innerBoxScreen screenPulsing innerMorning3"></div>
                            }
                        </div>
                        <div onClick={() => changeStep(4)} className="boxScreen">
                            {activeStep > 4 &&
                                <div className="innerBoxScreen innerMorning4"></div>
                            }
                            {activeStep === 4 &&
                                <div className="innerBoxScreen screenPulsing innerMorning4"></div>
                            }
                        </div>
                        <div onClick={() => changeStep(5)} className="boxScreen">
                            {activeStep > 5 &&
                                <div className="innerBoxScreen innerMorning5"></div>
                            }
                            {activeStep === 5 &&
                                <div className="innerBoxScreen screenPulsing innerMorning5"></div>
                            }
                        </div>
                        </div>

        </div>
    )
}

export default EatBlock;